import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Nota: La registrazione del Service Worker (PWA) è gestita automaticamente 
// da vite-plugin-pwa tramite l'opzione injectRegister: 'auto' in vite.config.ts.
// Non è necessario importare manualmente 'virtual:pwa-register' qui, 
// il che previene errori di modulo non trovato in alcuni ambienti di sviluppo.

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);